export const FORMS_VIEW_PREFERENCES_KEY = 'default/forms_view_preferences'
